import { AppRoute } from "app";
import { useAtomValue } from "jotai";
import { useNavigate } from "react-router-dom";

import { PointOfImpactList } from "pages/DamageLocation/PointOfImpactList";

import Flex from "components/Flex";
import Text from "components/Text";
import VehicleImpact from "components/VehicleImpact";

import { sessionIdAtom } from "atoms/sessionId";
import { useClientTranslation } from "hooks/useClientTranslation";
import { useEventTracking } from "hooks/useEventTracking";
import { replaceSessionInAppRoute } from "utils/routeHelper";

import { EditButton } from "../EditButton";

export const PointsOfImpactSection = () => {
  const navigate = useNavigate();
  const { trackEvent } = useEventTracking();
  const sessionId = useAtomValue(sessionIdAtom);

  const { t } = useClientTranslation();

  const onEdit = () => {
    trackEvent({
      name: "Claim Summary - edit",
      properties: {
        pageName: "Damage area",
      },
    });

    navigate(replaceSessionInAppRoute(AppRoute.DamageLocation, sessionId), { state: "FROM_SUMMARY" });
  };

  return (
    <>
      <Flex as="section" direction="row" justify="space-between" mb={16}>
        <Text as="h2" sizeVariant="lg" weight={500}>
          {t("damage_area.title")}
        </Text>
        <EditButton onClick={onEdit} />
      </Flex>
      <PointOfImpactList />
      <VehicleImpact editable={false} />
    </>
  );
};
